import {createRoot} from 'react-dom/client'
import './index.css'
import {Bootstrap} from './App.tsx'
import {store} from "./store.ts";
import {Provider} from "jotai";
import {queryClient} from "./services/queryClient.ts";
import {QueryClientProvider} from "@tanstack/react-query";
import {I18nextProvider} from "react-i18next";
import i18n from "./i18n.ts";

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        <I18nextProvider i18n={i18n}>
            <QueryClientProvider client={queryClient}>
                <Bootstrap/>
            </QueryClientProvider>
        </I18nextProvider>
    </Provider>
)
